export default __webpack_public_path__ + "static/media/automation-header-small.38f4c2c5.jpg";